import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/report-price"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const BulkAdd = async (values) => {
    return await axiosInstance(options).post(`${path}/bulk-add`, values);
}

export const Update = async (values) => {
    return await axiosInstance(options).put(`${path}/update`, values);
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}

export const Delete = async (values) => {
    return await axiosInstance(options).post(`${path}/delete`, values);
}
